import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import BottomNav from './components/BottomNav';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Search from './pages/Search';
import FoodLog from './pages/FoodLog';
import History from './pages/History';
import Favorites from './pages/Favorites';
import Settings from './pages/Settings';
import Help from './pages/Help';
import QuickAdd from './pages/QuickAdd';
import CustomFoods from './pages/CustomFoods';
import './App.css';

function AppContent() {
  const { user, loading } = useAuth();
  const location = useLocation();

  const publicPaths = ['/', '/login', '/register', '/forgot-password'];
  const showNav = user && !loading && !publicPaths.includes(location.pathname);

  return (
    <div className={`app ${showNav ? 'has-bottom-nav' : ''}`}>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />
        <Route path="/search" element={
          <ProtectedRoute><Search /></ProtectedRoute>
        } />
        <Route path="/log" element={
          <ProtectedRoute><FoodLog /></ProtectedRoute>
        } />
        <Route path="/log/:date" element={
          <ProtectedRoute><FoodLog /></ProtectedRoute>
        } />
        <Route path="/history" element={
          <ProtectedRoute><History /></ProtectedRoute>
        } />
        <Route path="/favorites" element={
          <ProtectedRoute><Favorites /></ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute><Settings /></ProtectedRoute>
        } />
        <Route path="/quick-add" element={
          <ProtectedRoute><QuickAdd /></ProtectedRoute>
        } />
        <Route path="/custom-foods" element={
          <ProtectedRoute><CustomFoods /></ProtectedRoute>
        } />
        <Route path="/help" element={
          <ProtectedRoute><Help /></ProtectedRoute>
        } />
      </Routes>
      {showNav && <BottomNav />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
